import React from 'react';
import styles from './GenericDetail.module.scss';
import {Else, If, Then, When} from 'react-if';
import ShowMoreText from 'gui/components/showMoreText';

interface IGenericDetail {
  icon?: any;
  title?: any;
  value?: any;
  children?: any;
  className?: string;
  valueClassName?: string;
  hideIcon?: boolean;
  enableScroller?: boolean;
  enableReadMore?: boolean;
}

const GenericDetail = (props: IGenericDetail) => {
  let components: any = <>
    <span className={`${styles.title} detailTitle`}>{props.title}:</span>
    &nbsp;
    <If condition={props.enableScroller}>
      <Then>{() =>
        <span className={props.enableScroller && styles.valueContainer}>
      <span className={`${styles.value} ${props.valueClassName} value detailValue`}>
      {props.value}
        {props.children}
    </span>
    </span>}
      </Then>
      <Else>
        {() => <span className={`${styles.value} ${props.valueClassName} value detailValue`}>
      {props.children}
       </span>}
      </Else>
    </If>
  </>

  if (props.enableReadMore) {
    components = (
      <ShowMoreText lines={1}
                    truncatedEndingComponent={<>&nbsp;</>}
                    showLabel="..."
                    className={styles.showMoreText}>{components}</ShowMoreText>

    );
  }

  return (
    <div className={`GenericDetail ${styles.GenericDetail} ${props.className}`.trim()}>
      <When condition={!!props.icon}>
        {() => <>
          <props.icon className={`sideIcon ${styles.icon}`}/>
          &nbsp;
        </>}
      </When>
      {components}
    </div>
  )
};

GenericDetail.defaultProps = {
  title: "",
  value: "",
  children: "",
  className: "",
  valueClassName: "",
  enableScroller: false,
  enableReadMore: false,
};
export default GenericDetail;
